class LogReminderService {
  constructor() {
    this.intervalId = null;
    this.callback = null;
  }

  startReminders(navigationId) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // 5 minutes
    this.intervalId = setInterval(() => {
      this.triggerReminder(navigationId);
    }, 5 * 60 * 1000);

    console.log('Rappels carnet démarrés (toutes les 5 min)');
  }

  triggerReminder(navigationId) {
    // JOUER LE SON
    const audio = new Audio('/notification-sound.mp3');
    audio.play().catch(err => console.log('Erreur son:', err));
    
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('📖 Carnet de bord', {
        body: 'Il est temps de remplir le carnet de bord !',
        icon: '/logo.png',
      });
    }

    if (this.callback) {
      this.callback(navigationId);
    }
  }

  onShowLogEntry(callback) {
    this.callback = callback;
  }

  stopReminders() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  reset() {
    this.stopReminders();
    this.callback = null;
  }
}

export const logReminderService = new LogReminderService();